"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

require("core-js/modules/es.array.index-of.js");

require("core-js/modules/es.string.replace.js");

require("core-js/modules/es.regexp.exec.js");

require("core-js/modules/es.array.every.js");

require("core-js/modules/es.array.for-each.js");

require("core-js/modules/web.dom-collections.for-each.js");

require("core-js/modules/es.array.is-array.js");

require("core-js/modules/es.array.concat.js");

require("core-js/modules/es.array.map.js");

require("core-js/modules/es.array.filter.js");

require("core-js/modules/es.object.define-property.js");

var _asyncValidator = _interopRequireDefault(require("async-validator"));

var _popover = _interopRequireDefault(require("element-ui/lib/popover"));

var _emitter = _interopRequireDefault(require("element-ui/lib/mixins/emitter"));

var _merge = _interopRequireDefault(require("element-ui/lib/utils/merge"));

var _util = require("element-ui/lib/utils/util");

var _skUtils = require("sk-utils");

var __vue_render__ = function __vue_render__(h) {
  var _vm = this;

  var _h = _vm.$createElement;
  var _c = h;
  return _c('div', {
    staticClass: "el-form-item",
    "class": [{
      'el-form-item--feedback': _vm.elForm && _vm.elForm.statusIcon,
      'is-error': _vm.validateState === 'error',
      'is-validating': _vm.validateState === 'validating',
      'is-success': _vm.validateState === 'success',
      // 扩展 只显示*(onlyRequiredLabel)
      'is-required': _vm.isRequired || _vm.required || _vm.onlyRequiredLabel
    }, _vm.sizeClass ? 'el-form-item--' + _vm.sizeClass : '', _vm.labelPosition ? 'el-form-item--' + (_vm.labelPosition + '-label') : ''],
    style: _vm._px2rem(_vm.itemStyle, 24, ['marginBottom']),
    attrs: {
      "conversionForbiddenPx2Rem": "marginBottom"
    }
  }, [_vm.label || _vm.$slots.label ? _c('label', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip.overflow",
      value: {
        content: _vm.label || ''
      },
      expression: "{ content: label || '' }",
      modifiers: {
        "overflow": true
      }
    }],
    staticClass: "el-form-item__label",
    style: _vm._px2rem(_vm.labelStyle, 24, []),
    attrs: {
      "for": _vm.labelFor
    }
  }, [_vm._t("label", [_vm._v(_vm._s(_vm.label + _vm.form.labelSuffix) + " ")], {})], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "el-form-item__content",
    style: _vm._px2rem(_vm.contentStyle, 24, []),
    attrs: {}
  }, [_vm._t("default", null, {}), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "el-zoom-in-top"
    }
  }, [_vm.showMessageInBottom ? _c('div', {
    staticClass: "el-form-item__error",
    "class": {
      'el-form-item__error--inline': typeof _vm.inlineMessage === 'boolean' ? _vm.inlineMessage : _vm.elForm && _vm.elForm.inlineMessage || false,
      //  扩展 新增ellipsisMessage，溢出时用...显示
      'el-form-item__error--ellipsis': _vm.ellipsisMessage
    },
    style: _vm._px2rem(_vm.errorContentStyle, 24, ['height', 'lineHeight']),
    attrs: {
      "conversionForbiddenPx2Rem": "height,lineHeight"
    }
  }, [_vm.ellipsisMessage ? _c('span', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip.overflow",
      modifiers: {
        "overflow": true
      }
    }],
    attrs: {}
  }, [_vm._v(_vm._s(_vm.validateMessage))]) : _c('span', [_vm._v(_vm._s(_vm.validateMessage))])]) : _vm._e()]), _vm._v(" "), _vm.tip ? _c('el-popover', {
    attrs: {
      "placement": "right-start",
      "trigger": "hover"
    }
  }, [_vm._t("tip", [_c('pre', {
    staticClass: "el-form-item__pre",
    attrs: {}
  }, [_vm._v(_vm._s(_vm.tip))])], {}), _vm._v(" "), _c('span', {
    "class": ['el-form-item__tip', _vm.position ? "is-" + _vm.position : ''],
    attrs: {
      "slot": "reference",
      "tabindex": "-1"
    },
    slot: "reference"
  }, [_c('i', {
    staticClass: "el-icon-question",
    attrs: {}
  })])], 2) : _vm._e()], 2)]);
};

var __vue_staticRenderFns__ = [];
var _default = {
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__,
  name: 'ElFormItem',
  componentName: 'ElFormItem',
  mixins: [_emitter["default"]],
  components: {
    ElPopover: _popover["default"]
  },
  provide: function provide() {
    return {
      elFormItem: this
    };
  },
  inject: ['elForm'],
  props: {
    label: String,
    width: String,
    labelWidth: String,
    prop: String,
    required: {
      type: Boolean,
      "default": undefined
    },
    rules: [Object, Array],
    error: String,
    validateStatus: String,
    "for": String,
    inlineMessage: {
      type: [String, Boolean],
      "default": ''
    },
    ellipsisMessage: {
      type: Boolean,
      "default": false
    },
    showMessage: {
      type: Boolean,
      "default": true
    },
    size: String,
    // 扩展 只显示*
    onlyRequiredLabel: {
      type: Boolean,
      "default": false
    },
    tip: {
      type: String
    },
    labelPosition: String
  },
  watch: {
    error: {
      immediate: true,
      handler: function handler(value) {
        this.validateMessage = value;
        this.validateState = value ? 'error' : '';
      }
    },
    validateStatus: function validateStatus(value) {
      this.validateState = value;
    }
  },
  computed: {
    showMessageInBottom: function showMessageInBottom() {
      return this.validateState === 'error' && this.showMessage && this.form.showMessage;
    },
    labelFor: function labelFor() {
      return this["for"] || this.prop;
    },
    labelStyle: function labelStyle() {
      var ret = {};
      if (this.position === 'top') return ret;
      var labelWidth = this.labelWidth || this.form.labelWidth;

      if (labelWidth) {
        ret.width = labelWidth;
      }

      return ret;
    },
    contentStyle: function contentStyle() {
      var ret = {};
      var label = this.label;
      var width = this.width || this.form.width;

      if (width) {
        ret.width = width;
      }

      if (this.position === 'top' || this.form.inline) return ret;
      if (!label && !this.labelWidth && this.isNested) return ret;
      var labelWidth = this.labelWidth || this.form.labelWidth;

      if (labelWidth) {
        ret.marginLeft = labelWidth;
      }

      return ret;
    },
    itemStyle: function itemStyle() {
      return _skUtils.toRem && this.showMessageInBottom ? {
        marginBottom: (0, _skUtils.remFontSizeMin12)(16) + 'px'
      } : {};
    },
    errorContentStyle: function errorContentStyle() {
      var height = (0, _skUtils.remFontSizeMin12)(15) + 'px';
      return _skUtils.toRem && this.showMessageInBottom ? {
        height: height,
        lineHeight: height
      } : {};
    },
    form: function form() {
      var parent = this.$parent;
      var parentName = parent.$options.componentName;

      while (parentName !== 'ElForm') {
        if (parentName === 'ElFormItem') {
          this.isNested = true;
        }

        parent = parent.$parent;
        parentName = parent.$options.componentName;
      }

      return parent;
    },
    fieldValue: function fieldValue() {
      var model = this.form.model;

      if (!model || !this.prop) {
        return;
      }

      var path = this.prop;

      if (path.indexOf(':') !== -1) {
        path = path.replace(/:/, '.');
      }

      return (0, _util.getPropByPath)(model, path, true).v;
    },
    isRequired: function isRequired() {
      var rules = this.getRules();
      var isRequired = false;

      if (rules && rules.length) {
        rules.every(function (rule) {
          if (rule.required) {
            isRequired = true;
            return false;
          }

          return true;
        });
      }

      return isRequired;
    },
    _formSize: function _formSize() {
      return this.elForm.size;
    },
    elFormItemSize: function elFormItemSize() {
      return this.size || this._formSize;
    },
    sizeClass: function sizeClass() {
      return this.elFormItemSize || (this.$ELEMENT || {}).size;
    },
    position: function position() {
      return this.labelPosition || this.form.labelPosition;
    }
  },
  data: function data() {
    return {
      validateState: '',
      validateMessage: '',
      validateDisabled: false,
      validator: {},
      isNested: false
    };
  },
  methods: {
    validate: function validate(trigger) {
      var _this = this;

      var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _util.noop;
      this.validateDisabled = false;
      var rules = this.getFilteredRule(trigger);

      if ((!rules || rules.length === 0) && this.required === undefined) {
        callback();
        return true;
      }

      this.validateState = 'validating';
      var descriptor = {};

      if (rules && rules.length > 0) {
        rules.forEach(function (rule) {
          delete rule.trigger;
        });
      }

      descriptor[this.prop] = rules;
      var validator = new _asyncValidator["default"](descriptor);
      var model = {};
      model[this.prop] = this.fieldValue;
      validator.validate(model, {
        firstFields: true
      }, function (errors, invalidFields) {
        _this.validateState = !errors ? 'success' : 'error';
        _this.validateMessage = errors ? errors[0].message : '';
        callback(_this.validateMessage, invalidFields);
        _this.elForm && _this.elForm.$emit('validate', _this.prop, !errors);
      });
    },
    clearValidate: function clearValidate() {
      this.validateState = '';
      this.validateMessage = '';
      this.validateDisabled = false;
    },
    resetField: function resetField() {
      this.validateState = '';
      this.validateMessage = '';
      var model = this.form.model;
      var value = this.fieldValue;
      var path = this.prop;

      if (path.indexOf(':') !== -1) {
        path = path.replace(/:/, '.');
      }

      var prop = (0, _util.getPropByPath)(model, path, true);
      this.validateDisabled = true;

      if (Array.isArray(value)) {
        prop.o[prop.k] = [].concat(this.initialValue);
      } else {
        prop.o[prop.k] = this.initialValue;
      }
      /* Select 的值被代码改变时不会触发校验，
         这里需要强行触发一次，刷新 validateDisabled 的值，
         确保 Select 下一次值改变时能正确触发校验 */


      this.broadcast('ElSelect', 'fieldReset');
      this.broadcast('ElTimeSelect', 'fieldReset', this.initialValue);
    },
    getRules: function getRules() {
      var formRules = this.form.rules;
      var selfRules = this.rules;
      var requiredRule = this.required !== undefined ? {
        required: !!this.required
      } : [];
      var prop = (0, _util.getPropByPath)(formRules, this.prop || '');
      formRules = formRules ? prop.o[this.prop || ''] || prop.v : [];
      return [].concat(selfRules || formRules || []).concat(requiredRule);
    },
    getFilteredRule: function getFilteredRule(trigger) {
      var rules = this.getRules();
      return rules.filter(function (rule) {
        if (!rule.trigger || trigger === '') return true;

        if (Array.isArray(rule.trigger)) {
          return rule.trigger.indexOf(trigger) > -1;
        } else {
          return rule.trigger === trigger;
        }
      }).map(function (rule) {
        return (0, _merge["default"])({}, rule);
      });
    },
    onFieldBlur: function onFieldBlur() {
      this.validate('blur');
    },
    onFieldChange: function onFieldChange() {
      if (this.validateDisabled) {
        this.validateDisabled = false;
        return;
      }

      this.validate('change');
    }
  },
  mounted: function mounted() {
    if (this.prop) {
      this.dispatch('ElForm', 'el.form.addField', [this]);
      var initialValue = this.fieldValue;

      if (Array.isArray(initialValue)) {
        initialValue = [].concat(initialValue);
      }

      Object.defineProperty(this, 'initialValue', {
        value: initialValue
      });
      var rules = this.getRules();

      if (rules.length || this.required !== undefined) {
        this.$on('el.form.blur', this.onFieldBlur);
        this.$on('el.form.change', this.onFieldChange);
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.dispatch('ElForm', 'el.form.removeField', [this]);
  }
};
exports["default"] = _default;